import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line headline reveal
export const MaskLines = ({ lines, className = "", lineClassName = "", start = 0, stagger = 0.09 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-line">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: start + i * stagger, ease }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const MaskLinesInView = ({ lines, className = "", lineClassName = "", stagger = 0.09 }) => (
  <motion.span
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
  >
    {lines.map((line, i) => (
      <span key={i} className="reveal-line">
        <motion.span
          className={`block ${lineClassName}`}
          variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
          transition={{ duration: 0.9, delay: i * stagger, ease }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
